<template>
    <div>
        <div class="row">
            <div class="col-12">
                <p>
                    Zadejte platné IČO firmy, kterou chcete přidat do katalogu
                </p>

                <div class="form-group">
                    <input
                        v-model="$v.searchText.$model"
                        v-focus
                        type="text"
                        placeholder="Zadejte IČO"
                        class="form-control"
                    />
                    <div v-if="$v.searchText.$error" class="validator">
                        <span class="error-s">IČO musí být číslo</span>
                    </div>
                </div>
                <button class="button-02" @click="getAresData">
                    Načíst údaje o firmě
                </button>
            </div>
        </div>

        <section v-if="firm.ares_data.ico > 0">
            <div class="row">
                <div class="col-12">
                    <div class="py-3">
                        <span class="title1">1. Základní údaje</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    {{ firm.ares_data.firma }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 col-sm-2">
                    Obec:
                </div>
                <div class="col-6 col-sm-10">
                    {{ firm.ares_data.mesto }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 col-sm-2">
                    Ulice:
                </div>
                <div class="col-6 col-sm-10">
                    {{ firm.ares_data.ulice }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 col-sm-2">
                    Č.p.:
                </div>
                <div class="col-6 col-sm-10">
                    {{ firm.ares_data.cislo }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 col-sm-2">
                    PSČ:
                </div>
                <div class="col-6 col-sm-10">
                    {{ firm.ares_data.psc }}
                </div>
            </div>
            <div class="row">
                <div class="col-6 col-sm-2">
                    IČO:
                </div>
                <div class="col-6 col-sm-10">
                    {{ firm.ares_data.ico }}
                </div>
            </div>

            <div class="row">
                <div class="col-6 col-sm-2">
                    DIČ:
                </div>
                <div class="col-6 col-sm-10">
                    {{ firm.ares_data.dic }}
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="py-3">
                        <span class="title1">2. Kontaktní údaje</span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <p class="small">
                        Zadejte hlavní email a telefon firmy. Další kontaktní
                        údaje můžete přidávat v servisní sekci.
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <svg
                                    width="20px"
                                    height="20px"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="far"
                                    data-icon="envelope"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
                                    ></path>
                                </svg>
                            </div>
                        </div>

                        <input
                            v-model="$v.firm.form_data.email.$model"
                            placeholder="Email *"
                            class="form-control"
                        />
                        <div
                            v-if="$v.firm.form_data.email.$error"
                            class="validator"
                        >
                            <span class="error-s">Zadejte prosím email</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <svg
                                    width="20px"
                                    height="20px"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="mobile-alt"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 320 512"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
                                    ></path>
                                </svg>
                            </div>
                        </div>
                        <input
                            v-model="$v.firm.form_data.telefon.$model"
                            placeholder="Telefon *"
                            class="form-control"
                        />
                        <div
                            v-if="$v.firm.form_data.telefon.$error"
                            class="validator"
                        >
                            <span class="error-s">Zadejte prosím telefon</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <div class="input-group-text">
                                <svg
                                    width="20px"
                                    height="20px"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fas"
                                    data-icon="globe"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 496 512"
                                >
                                    <path
                                        fill="currentColor"
                                        d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
                                    ></path>
                                </svg>
                            </div>
                        </div>
                        <input
                            v-model="$v.firm.form_data.www.$model"
                            placeholder="www stránky"
                            class="form-control"
                        />
                        <div
                            v-if="$v.firm.form_data.www.$error"
                            class="validator"
                        >
                            <span class="error-s">
                                Zadejte prosím WWW (včetně http:// nebo
                                https://)
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!--            <div class="row">-->
            <!--                <div class="col-12">-->
            <!--                    <div class="py-3">-->
            <!--                        <span class="title1">-->
            <!--                            3. Základní popis (300 znaků)-->
            <!--                        </span>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <!--            <div class="row">-->
            <!--                <div class="col-12">-->
            <!--                    <div class="input-group mb-3">-->
            <!--                        <textarea-->
            <!--                            v-model.trim="$v.firm.form_data.popis.$model"-->
            <!--                            rows="5"-->
            <!--                            class="form-control"-->
            <!--                        ></textarea>-->
            <!--                        <div-->
            <!--                            v-if="$v.firm.form_data.popis.$error"-->
            <!--                            class="validator"-->
            <!--                        >-->
            <!--                            <span class="error-s">Zadejte prosím popis</span>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
        </section>

        <div class="row mt-5">
            <div class="col-6 col-sm-2">
                <button
                    class="button-01"
                    @click="$store.commit('step/setStep', 'search')"
                >
                    Zpět
                </button>
            </div>
            <div class="col-6 col-sm-10">
                <button
                    v-if="firm.ares_data.ico != ''"
                    class="button-02"
                    @click="submit()"
                >
                    Pokračovat
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from "axios";

import { validationMixin } from 'vuelidate'
import {
    required,
    email,
    url,
    maxLength,
    minLength,
    numeric,
} from 'vuelidate/lib/validators'

export default {
    name: 'FormWizardFirmRegister',
    mixins: [validationMixin],
    /*
  props: {
    firm: {
      type: Object,
      required: true
    }
  },
  */
    computed: {
        firm() {
            return this.$store.state.firm
        },

        searchText: {
            get() {
                return this.$store.state.search.searchText
            },
            set(value) {
                this.$store.dispatch('search/setSearchText', value)
            },
        },
        userId() {
            return this.$store.state.user.id
        },
    },
    validations: {
        searchText: {
            numeric,
        },
        firm: {
            form_data: {
                email: {
                    required,
                    email,
                },
                telefon: {
                    required,
                    minLength: minLength(6),
                },
                www: {
                    url,
                },
                popis: {
                    maxLength: maxLength(300),
                },
            },
            ares_data: {
                firma: {
                    minLength: minLength(3),
                },
            },
        },
    },
    methods: {
        submit() {
            this.$v.firm.$touch()
            if (this.$v.firm.$invalid) {
                console.log('formular neni validni')
            } else {
                this.$store.commit('firm/setFormData', this.firm.form_data)
                this.$store.commit('step/setStep', 'presentation')
                // Klik na tlačítko Pokračocat po načtení dat z ARES s + prametrem ID firmy
                ga('p.send', 'event', 'firmy-krok1-klik', this.userId)
            }
        },
        getAresData() {
            this.$v.searchText.$touch()
            if (this.$v.searchText.$invalid) {
                return
            }
            let vm = this
            this.$store
                .dispatch('firm/isIcoRegistered', this.searchText)
                .then(response => {
                    if (response) {
                        /*
                        this.$store.dispatch(
                            'loader/setError',
                            'Firmu nelze přidat, IČO již je registrované.'
                        )
                        */
                        this.$store.commit('step/setStep', 'search')
                    } else {
                        this.$store.dispatch(
                            'loader/setLoader',
                            'Načítám firmu z ARES ...',
                            { root: true }
                        )
                        this.$store
                            .dispatch('firm/getAresData', vm.searchText)
                            .then(status => {
                                if (status) {
                                    this.$store.dispatch('loader/setLoader', '')
                                    // Pokud se zobrazí správně načtené Údaje ARES
                                    ga(
                                        'p.send',
                                        'event',
                                        'firmy-udaje-ares',
                                        this.userId
                                    )
                                } else {
                                    this.$store.dispatch(
                                        'loader/setError',
                                        'Nepodařilo se načíst firmu z ARES'
                                    )
                                }
                            })
                            .catch(error => {
                                console.log(error)
                                this.$store.dispatch('loader/setError', error)
                            })
                    }
                })
                .catch(error => {
                    this.$store.dispatch('loader/setError', error)
                })
        },
    },
}
</script>
